import React, { useState } from "react";
import { login, signup } from "../api";

export default function Login({ onLoggedIn }) {
  const [mode, setMode] = useState("login"); // "login" | "signup"
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const isSignup = mode === "signup";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (isSignup) {
        await signup(username, password);
      } else {
        await login(username, password);
      }
      onLoggedIn();
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Trade Your Strat</h1>
        <p className="muted">
          {isSignup
            ? "Create your own account to trade your own Zerodha account here."
            : "Sign in to continue."}
        </p>

        <div className="field-group">
          <label>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
          />
        </div>

        <div className="field-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={isSignup ? "new-password" : "current-password"}
          />
          {isSignup && <p className="hint" style={{ marginTop: 6 }}>At least 6 characters.</p>}
        </div>

        {error && <div className="banner error">{error}</div>}

        <button type="submit" disabled={busy}>
          {busy ? "Please wait..." : isSignup ? "Create account" : "Sign in"}
        </button>

        <p className="muted" style={{ textAlign: "center", marginTop: 14, marginBottom: 0 }}>
          {isSignup ? (
            <>
              Already have an account?{" "}
              <a href="#login" onClick={(e) => { e.preventDefault(); setMode("login"); setError(null); }}>
                Sign in
              </a>
            </>
          ) : (
            <>
              New here?{" "}
              <a href="#signup" onClick={(e) => { e.preventDefault(); setMode("signup"); setError(null); }}>
                Create an account
              </a>
            </>
          )}
        </p>
      </form>
    </div>
  );
}
